export enum ENUM_ATTENDANCE_EXCEPTION_STATUS {
  PENDING = "pending",
  APPROVED = "approved",
  AUTO_APPROVED = "auto_approved",
  REJECTED = "rejected",
  CANCELLED = "cancelled",
}

export enum ENUM_ATTENDANCE_REQUEST_TYPE {
  CHECK_IN = "check_in",
  CHECK_OUT = "check_out",
}
